'use client';

/**
 * The "your English is fine" result.
 *
 * A clean check deserves an answer you can read at a glance, not a sentence
 * explaining that there is nothing to explain. Someone who writes well gets a
 * clear signal and moves on; someone who does not still gets the full report.
 *
 * Gold rather than the app's indigo: this is the one moment in the product that
 * is a reward, and the accent colour is used everywhere else for controls.
 */
export default function NoMistakes() {
  return (
    <div className="flex h-full flex-col items-center justify-center py-6 text-center">
      <svg
        viewBox="0 0 24 24"
        className="h-20 w-20 drop-shadow-[0_4px_14px_rgba(234,179,8,0.35)]"
        role="img"
        aria-label="No mistakes found"
      >
        <defs>
          <linearGradient id="gt-gold" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#fde047" />
            <stop offset="55%" stopColor="#f5b921" />
            <stop offset="100%" stopColor="#d99413" />
          </linearGradient>
        </defs>
        {/* Thumbs-up, drawn as one filled shape so it reads solid at this size
            rather than as thin outlines. */}
        <path
          fill="url(#gt-gold)"
          d="M6.6 20.9H4.5a1.6 1.6 0 0 1-1.6-1.6v-7.2a1.6 1.6 0 0 1 1.6-1.6h2.1zM8.4 10.3l3.6-7.1a1 1 0 0 1 1.3-.5l.6.3a2.7 2.7 0 0 1 1.4 3l-.7 3.3h4.1a2.2 2.2 0 0 1 2.2 2.7l-1.4 6.6a2.7 2.7 0 0 1-2.6 2.2H8.4z"
        />
      </svg>

      <p className="mt-4 text-xl font-semibold text-ink-800 dark:text-ink-dim">No mistakes</p>
      <p className="mt-1 max-w-xs text-sm text-ink-500 dark:text-ink-400">
        This reads naturally. Nothing here would make a native speaker pause.
      </p>
    </div>
  );
}
